var React = require('react');

function IcRouterActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FF6400","fillRule":"evenodd","d":"M26.933 5.867L28 4.8C26.244 3.009 23.841 2 21.334 2c-2.508 0-4.911 1.009-6.667 2.8l1.067 1.067c1.518-1.43 3.516-2.238 5.6-2.267 2.084.029 4.082.837 5.6 2.267h-.001zm-1.2 1.067c-1.153-1.193-2.74-1.867-4.4-1.867-1.66 0-3.247.674-4.4 1.867L18 8c1.867-1.779 4.8-1.779 6.667 0l1.066-1.066zm3.6 9.733h-6.666V10H20v6.667H2.667C1.197 16.67.005 17.862 0 19.333v8c.004 1.47 1.196 2.662 2.667 2.667h26.666c1.471-.005 2.663-1.196 2.667-2.667v-8c-.005-1.471-1.196-2.662-2.667-2.666zm-22.667 8H4V22h2.667l-.001 2.667zm4.667 0H8.667V22h2.666v2.667zm4.667 0h-2.667V22H16v2.667z"}));
}

IcRouterActive.defaultProps = {"id":"ic-router-active","viewBox":"0 0 32 32"};

module.exports = IcRouterActive;

IcRouterActive.default = IcRouterActive;
